import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateUser , getUserInfo} from '../../common/actions/userActions';
import { isEmpty } from '../../common/cores';
import { DatePicker } from 'antd';
import moment from 'moment';

const ChangeUserInfo = (props) => {

  const dateFormat = 'YYYY-MM-DD';
  const { user, bankList } = props;

  const [inputs, setInputs] = useState({
    oldPwd: '',
    loginPwd: '',
    loginPwd_confirm: '',
    name: user.name,
    tel: user.tel,
    bankName: !isEmpty(user.accountInfo) && user.accountInfo.bankName,
    accountNumber: !isEmpty(user.accountInfo) && user.accountInfo.accountNumber,
    masterName: !isEmpty(user.accountInfo) && user.accountInfo.masterName, 
    birthday: user.birthday, 
    gender: !isEmpty(user.gender) && user.gender.toString(),
  });

  const [error, setError ] = useState({});

  useEffect(() => {
    setInputs({
            name: user.name, 
            tel: user.tel,  
            bankName: !isEmpty(user.accountInfo) && user.accountInfo.bankName,
            accountNumber: !isEmpty(user.accountInfo) && user.accountInfo.accountNumber,
            masterName: !isEmpty(user.accountInfo) && user.accountInfo.masterName, 
            birthday: user.birthday, 
            gender: !isEmpty(user.gender) && user.gender.toString()
        })
    }, [user]);

   const { oldPwd, 
            loginPwd, 
            loginPwd_confirm, 
            name, 
            tel,
            bankName,
            accountNumber,
            masterName, 
            birthday, 
            gender 
    } = inputs;

  //   const dispatch = useDispatch();

 

  const onChange = (e) => {
    const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    setInputs({
      ...inputs, // 기존의 input 객체를 복사한 뒤
      [name]: value // name 키를 가진 값을 value 로 설정
    });
  };

  const onChangeBirthday = (date, dateString) => {
    // console.log("====================>", date, dateString);
    setInputs({
        ...inputs,
        birthday: dateString
    });
}

  const onReset = (e) => {

    setInputs({
      oldPwd: "",
      loginPwd: "",
      loginPwd_confirm: ""
    })
  };

  const onSetBank = (value) => {
    setInputs({
        ...inputs, // 기존의 input 객체를 복사한 뒤
        bankName: value // name 키를 가진 값을 value 로 설정
    });
}

const onUpdateUser = () => {
    let params = {
            name, 
            tel, 
            bankName,
            accountNumber,
            masterName, 
            birthday, 
            gender: Number(gender),
    }
    // updateUser(params)
    props.updateUser(params).then(res => {
        if (res.status) {
            if (!isEmpty(res.errors)) {
                    setError(res.errors);
            }
    }
    else {
            setError({});
            props.getUserInfo();
    }
            console.log('=================================>', params)
    });
    // onReset();
}


  const onSubmit = () => {
    let params = {
      oldPwd,
      loginPwd,
      loginPwd_confirm
    }
    // updateUser(params)
    props.updateUser(params);
    onReset();
  }


  const onEnter = (e) => {
    // e.preventDefault();
    if (e.key === 'Enter') {
      // e.preventDefault();
      onSubmit(e);
    }
  }
  return (
    <Fragment>
      <div className="con_box10">
        <div className="write_wrap">
          <div className="write3">
            <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
              <tbody>
                <tr>
                  <td className="write_title">아이디</td>
                  <td className="write_basic">
                    {user.loginId}
                  </td>
                </tr>
                <tr>
                  <td className="write_title">닉네임</td>
                  <td className="write_basic">
                    <input
                      name="name"
                      onChange={onChange}
                      value={name}
                      type="text"
                      inputMode="text"
                      className="input1"
                    />
                   </td>
                </tr>
                {/* <tr>
                  <td className="write_title">생년월일</td>
                  <td className="write_basic pc-mobile-reg">
                    <div className="">
                        <DatePicker  defaultValue={moment('1990-01-01', dateFormat)} onChange={onChangeBirthday} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="write_title">성별</td>
                  <td className="write_basic pc-mobile-reg">
                    <div className = "input-control">
                        <label class="radio_container pr-4">남성
                            <input type="checkbox" name="gender" checked={gender === '1' && "checked"}  className="sex_input" value="1" onChange={onChange}/>
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio_container">여성
                            <input type="checkbox" name="gender" checked={gender === '0' && "checked"} className="sex_input" value="0" onChange={onChange}/>
                        <span class="checkmark"></span>
                        </label>
                    </div>
                  </td>
                </tr> */}
                <tr>
                  <td className="write_title">휴대폰번호</td>
                  <td className="write_basic pc-mobile-reg">
                    <input
                        name="tel"
                        onChange={onChange}
                        value={tel}
                        type="text"
                        inputMode="text"
                        className="input1"
                        />
                  </td>
                </tr>
                <tr>
                    <td className= 'write_title'>은행명</td>
                    <td className='write_basic pc-mobile-reg'>
                    <select className="input1 bankSelect" 
                        onChange={onChange}
                        name="bankName">
                        <option defaultValue="">은행선택</option>
                        {
                            !isEmpty(bankList) && bankList.map((list, index) => {
                                return(<option defaultValue={list.bankName} key={index}>{list.bankName}</option>)
                            })
                        }
                    </select>
                    </td>
                </tr>

                <tr>
                    <td className= 'write_title'>예금주</td>
                    <td className='write_basic pc-mobile-reg'>
                        <input
                            name="masterName"
                            onChange={onChange}
                            value={masterName}
                            type="text"
                            inputMode="text"
                            className="input1"
                            />
                    </td>
                </tr>

                <tr>
                    <td className= 'write_title'>계좌번호</td>
                    <td className='write_basic pc-mobile-reg'>
                        <input
                            name="accountNumber"
                            onChange={onChange}
                            value={accountNumber}
                            type="text"
                            inputMode="text"
                            className="input1"
                        />
                    </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="con_box30">
        <div className="btn_wrap_center">
          <ul>
            <li><a><span className="btn3_1" onClick={onUpdateUser}>정보수정</span></a></li>
          </ul>
        </div>
      </div>
    </Fragment>

  )
}

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  user: state.user.data,
  bankList: state.user.bankList
});


export default connect(mapStateToProps, {
  updateUser, getUserInfo
})(ChangeUserInfo);


// WEBPACK FOOTER //
// ./src/components/account/ChangeUserInfo.js